/**
 * @param {string} key
 * @return {string | null}
 */
class LocalStorageCache {
    /**
     * @param {string} key
     * @return {string | null}
     */
    get(key) {
        var _a;
        return (_a = window.localStorage.getItem(key)) !== null && _a !== void 0 ? _a : null;
    }
    /**
     * @param {string} key
     * @return {string | null}
     */
    has(key) {
        return !!window.localStorage.getItem(key);
    }
    /**
     * @param {string} key
     * @param {boolean|string} value
     * @return {Promise<undefined>}
     */
    set(key, value) {
        window.localStorage.setItem(key, String(value));
        return Promise.resolve();
    }
}
export default LocalStorageCache;
